/*!
 * fds-flight-chart.js -- DE-MINIFIED 2026-08-06. Behaviour identical to the
 * previous single-line build (verified by SVG-path snapshot across 7 cases).
 *
 * There is NO build step. THIS FILE IS THE SOURCE. Edit it and upload it.
 * Identifiers are still minified -- beautifying does not rename. Map:
 *
 *   E(turn,fade,speed,mir,glide)  curve control points; mirror applies to x only
 *   GM(speed,glide)     fade-pull multiplier: glide short for its speed dumps
 *   A(disc)             flight geometry: dist + 4 bezier points
 *   it()                MAIN RENDER: viewBox, gridlines, every flight path
 *   ct()                renders the YOUR BAG slot list
 *   hero()              renders the focused-disc readout + stat row
 *   ax() / AX           axis scale memo; AX.maxFt is the top of the fairway
 *   ft2u / u2ft         feet <-> SVG units
 *   Ax(g,box,c)         draws distance gridlines + labels
 *   bqlbl(svg,labels,c) places endpoint labels; de-overlap + leader lines
 *   Vt()                URL hash SERIALISER (d=, t=, r=, p=)
 *   Ut()                URL hash PARSER
 *   Y(disc)             distance as a display string
 *   W()                 power scale factor
 *   j(disc)             base distance from speed+glide
 *   L(disc) / L0(disc)  length factor: throttled / unthrottled
 *   H(disc)             identity key: vendor|mold
 *   I(disc)             slug
 *   B(n)                number to 1dp string
 *   _(s)                HTML escape
 *   T(tag,attrs)        SVG element factory
 *   g(v,lo,hi)          clamp
 *
 *   Q                   the bag: array of mould objects (shared by identity with the master list)
 *   X                   bag membership map, keyed H(disc) -- becomes H+throw for per-disc throw
 *   N                   GLOBAL throw type string: RHBH | RHFH | LHBH | LHFH
 *   R                   throw table: {RHBH:{mirror:1}, ...}
 *   MIR(disc)           mirror for a disc: its own __thr, else the global N
 *   SL(mould,thr)       makes a SLOT: Object.create(mould) + own __thr, so reads
 *                       inherit and nothing is written to the shared mould object
 *   TK(slot)            slot key = vendor|mold|THROW. Focus, colour and dedupe key
 *                       off THIS, not H(), so one mould can be bagged both ways
 *   X                   MOULD-keyed COUNT (not 1); "is this disc bagged" still works
 *   reX()               rebuilds X from Q after any mutation
 *   S                   slug -> mould
 *   F                   vendor|mold -> mould
 *   O                   index -> mould (comparables resolve through this)
 *   V                   reference mould (seeds the axis even when not bagged)
 *   U                   power number (throw distance for the reference mould)
 *   z                   units: "m" or "ft"
 *   w                   throttle / snap slider value
 *   FO                  focus index into Q
 *   J                   sort state {by,dir}
 *   v,y,b               tee x = 120, tee y = 214, usable vertical SVG units = 185
 *   D                   0.3048 (ft -> m)
 *   C2T                 turn-to-fade asymmetry function
 *   BAGS                preset bags
 *
 * Gotcha: Q holds objects shared by identity with the master mould list. Never
 * stash per-disc state on a mould object -- key it off H(disc) in a side map.
 */
! function() {
  var t = window.__FDS_RAW__,
    e = t.m.map(function(e) {
      return {
        v: t.V[e[0]],
        m: e[1],
        t: t.T[e[2]],
        s: e[3],
        g: e[4],
        tu: e[5],
        f: e[6],
        st: t.ST[e[7]],
        as: e[8] < 0 ? null : t.AS[e[8]],
        n: e[9],
        stock: e[10],
        _c: e[11],
        /* Provenance, field 12. Shipped since the register sweep and never
           read until now: it is how a suggestion can prefer a number the
           manufacturer published over one scraped off an aggregator. */
        src: t.SRC ? t.SRC[e[12]] : ""
      }
    });
  e.forEach(function(t) {
    t.cmp = t._c.map(function(t) {
      return e[t].v + " " + e[t].m
    }), delete t._c
  }), window.__FDS__ = {
    molds: e,
    noflight: t.g.map(function(e) {
      return {
        v: t.V[e[0]],
        m: e[1]
      }
    })
  }
}(),
function() {
  "use strict";
  var t = window.__FDS__,
    e = t.molds,
    n = t.noflight,
    r = {
      DD: "Distance Driver",
      FD: "Fairway Driver",
      MR: "Midrange",
      PA: "Putt & Approach"
    },
    a = ["DD", "FD", "MR", "PA"],
    /* ONE TAXONOMY, KEYED OFF SPEED. 7 Sep 2026, Ryan's ruling: fairway
       drivers stop at 9, so distance starts at 10. This replaces every read of
       the mould's own `t` label in this file -- the catalogue filter, the
       facets, the reference-mould groups and the bouquet's band walk -- because
       a label that disagreed with the rule put a Firebird and a Discraft Raptor
       in different categories despite identical flight numbers. Same function
       as grid.js bandOf(). */
    BND = function(t) {
      /* A variant is whatever its base mould is -- Zone SS is a Zone, so it is
         a putter even though 4/4/-1/2 reads midrange. Mirrors grid.js
         bandOf(); see the note there. Only speed 4-5 consults the family. */
      if (t.s >= 4 && t.s <= 5) {
        var sp = t.m.indexOf(" ");
        if (sp > 0) {
          var b = S[I({ v: t.v, m: t.m.slice(0, sp) })];
          if (b) return BND(b)
        }
      }
      return t.s >= 10 ? "DD" : t.s >= 6 ? "FD" : t.s >= 4 ? (4 === t.s && t.g <= 3 ? "PA" : "MR") : "PA"
    },
    o = ["Very Understable", "Understable", "Stable", "Overstable", "Very Overstable"],
    i = ["Any", "Low", "Moderate", "High", "Very high"];

  function s(t) {
    var e = i.indexOf(t.as);
    return e < 0 && (e = 2), [e, t.tu + t.f, -t.g]
  }
  var d = ["var(--s1)", "var(--s2)", "var(--s3)"],
    DASH = [0, 1, 2],
    l = .042,
    c = .029,
    u = 1.95,
    f = .05,
    h = .56,
    p = .93,
    m = .1,
    v = 120,
    y = 214,
    b = 185,
    FB = 2.2;

  function g(t, e, n) {
    return t < e ? e : t > n ? n : t
  }
  /* FADE IS NOT DILUTED BY GLIDE ANY MORE.
     Ryan, looking at the example bag: "look at the roc3 and the gator... the
     gator is wayyyyy more overstable". He is right, and the chart could not
     see it. Innova publishes both at 0 turn / 3 fade, so the only thing that
     separated them was glide -- and glide was working BACKWARDS. It fed the
     distance term, so the Roc3 (glide 4) flew further and therefore drew
     FURTHER offline than the Gator (glide 2), which is the opposite of what
     either disc does on a course.

     Glide is lift. A floaty disc carries through its fade and lands long; a
     low-glide disc drops out of the air and dumps. So the same fade rating
     buys MORE lateral finish on a low-glide disc.

     THE DIVISOR IS GLIDE RELATIVE TO SPEED, NOT GLIDE. The first attempt
     divided by raw glide and it broke the top of the bag: an XCaliber (12/5)
     came out LESS overstable than before, because glide 5 scored as "high"
     when for a speed-12 driver it is simply normal. Median glide across all
     1,614 moulds is 5 at speed 5 and above, 3 below it -- so that is the
     expectation a disc is measured against. A Firebird carries 3 where its
     class carries 5; a Gator carries 2 where its class carries 5; an XCaliber
     and a Destroyer carry exactly what their class carries and do not move at
     all. Only the genuine dumpers change, which is the point.

     Square root because the effect is real but not linear. Glide is floored at
     2 because a power law goes silly in the tail -- without it a glide-1 Rhyno
     claims a 31 ft finish off a 200 ft flight, a worse lie than the one being
     fixed. 101 moulds of 1,614 change column; the funnel stays 5/5/5/3.

     THE EXPONENT IS THE DIAL. Raise it and every low-glide disc finishes
     harder; the shape of the ordering does not change, only its spread. */
  var GLIDE_LO = 2,
    GLIDE_HI = 7,
    GLIDE_K = .5;

  function EXPG(sp) {
    return sp >= 5 ? 5 : 3
  }

  function GM(sp, gl) {
    return null == gl ? 1 : Math.pow(EXPG(sp) / g(gl, GLIDE_LO, GLIDE_HI), GLIDE_K)
  }

  function C2T(t) {
    return t > 0 ? u : .25
  }

  function MIR(t) {
    return R[t && t.__thr || N].mirror
  }

  function E(t, e, n, mir, gl) {
    var r = -t * l,
      a = -e * c * GM(n, gl),
      o = g((14 - n) / 12, 0, 1),
      i = h + o * m,
      s = void 0 === mir ? R[N].mirror : mir,
      x2r = C2T(r) * r + f * a,
      x3v = r + a,
      bk = FB * (0 - a);
    if (x2r - x3v > bk) x2r = x3v + bk;
    return {
      x1: 0,
      y1: -i,
      x2: s * x2r,
      y2: -p,
      x3: s * x3v,
      y3: -1
    }
  }

  function x(t) {
    for (var e = 0, n = 0, r = 0, a = 1; a <= 48; a++) {
      var o = a / 48,
        i = 1 - o,
        s = 3 * i * i * o * t.x1 + 3 * i * o * o * t.x2 + o * o * o * t.x3,
        d = 3 * i * i * o * t.y1 + 3 * i * o * o * t.y2 + o * o * o * t.y3;
      r += Math.hypot(s - e, d - n), e = s, n = d
    }
    return r
  }
  var w = 0;
  // FHR = forehand distance as a fraction of backhand. 1 = no assumption either
  // way. Some players throw a longer forehand than backhand; the control runs
  // both sides of 100%.
  var FHR = 1;

  function isFH(t) {
    return "FH" === (t && t.__thr || N).slice(2)
  }
  // per-disc power: the global scale, adjusted if this slot is a forehand
  function Wd(t) {
    return W() * (isFH(t) ? FHR : 1)
  }

  function C(t) {
    /* "even more fade out applied". The global under-power term stays -- that
       is the player -- and the disc's own overspeed is added on top, so a
       Destroyer dumps harder than an Aviar for the same arm instead of the two
       being shifted by an identical amount. Negative, because k() reads
       negative C as "flip it stable and let the fade run". */
    return Wd(t) - 1 + w - CEIL.OP * OVER(t)
  }

  function FK(n) {
    return n < 0 ? 2.2 : .45
  }

  function TL(o) {
    return o < 0 ? .36 : .2
  }

  function k(t) {
    var e, n = (e = 1.6 * C(t), 2.2 * Math.tanh(e / 2.2));
    return {
      turn: t.tu - n,
      fade: Math.max(0, t.f - FK(n) * n)
    }
  }

  /* GROUND CONTACT TRUNCATES THE LINE. Ryan: a disc "can't possibly continue
     on the ground when hitting grass", so pure line-conservation is wrong. No
     height axis exists, so GLIDE proxies airtime: fade beyond what glide
     supports is fade the disc never lives to express. Keys off fade, so it
     touches 100% of overstable moulds and 0% of understable ones -- which is
     why rollers and flip-ups are never wrongly cut. Scales the flight rather
     than clipping the tail; skip is not modelled. */
  function GT(t) {
    if (!CEIL.on) return 1;
    var ef = k(t).fade,
      cap = CEIL.GC * (t.g == null ? 3 : t.g),
      ex = Math.max(0, ef - cap);
    return 1 / (1 + CEIL.TR * ex)
  }

  function L(t) {
    if (!w && Math.abs(C(t)) < 1e-6 && GT(t) === 1) return 1;
    var e = E(t.tu, t.f, t.s, MIR(t), t.g),
      n = k(t),
      r = x(E(n.turn, n.fade, t.s, MIR(t), t.g)),
      a = r > 0 ? x(e) / r : 1;
    return (1 + TL(w) * w) * a * GT(t)
  }
  var AX = {
    maxFt: 400,
    step: 50,
    key: ""
  };

  function L0(t) {
    var n = Wd(t) - 1;
    if (Math.abs(n) < 1e-6) return 1;
    var r = 2.2 * Math.tanh(1.6 * n / 2.2),
      a = x(E(t.tu - r, Math.max(0, t.f - FK(r) * r), t.s, MIR(t), t.g));
    return a > 0 ? x(E(t.tu, t.f, t.s, MIR(t), t.g)) / a : 1
  }

  function ax() {
    var t = W() + "|" + z + "|" + Q.length + "|" + (V ? V.m : "") + "|" + Math.round(10 * w) + "|" + FHR + "|" + Q.map(TK).join(",");
    if (AX.key === t) return;
    AX.key = t;
    var n = V ? W() * j(V) * Math.max(L0(V), L(V)) : 350;
    Q.forEach(function(t) {
      var e = Wd(t) * j(t) * Math.max(L0(t), L(t));
      e > n && (n = e)
    });
    var r = "m" === z ? n < 200 ? 10 / D : 20 / D : n < 300 ? 25 : 50,
      q2 = "m" === z ? 5 / D : 10;
    AX.step = r, AX.maxFt = Math.max(2 * r, Math.ceil(n * 1.06 / q2) * q2)
  }

  function ft2u(t) {
    return b * t / AX.maxFt
  }

  function u2ft(t) {
    return t * AX.maxFt / b
  }

  function axl(t) {
    return "m" === z ? Math.round(t * D) + " m" : Math.round(t) + " ft"
  }

  function Ax(n, r, c) {
    ax();
    for (var a = AX.step; a <= AX.maxFt + 1e-6; a += AX.step) {
      var o = y - ft2u(a);
      if (o < r.y - 1) break;
      n.appendChild(T("line", {
        x1: r.x,
        y1: o,
        x2: r.x + r.w,
        y2: o,
        stroke: "var(--field-line)",
        "stroke-width": 1.2 * c,
        "stroke-dasharray": (1.4 * c).toFixed(2) + " " + (5 * c).toFixed(2)
      }));
      var i = T("text", {
        x: r.x + 5 * c,
        y: o - 3.4 * c,
        "font-size": 10.5 * c,
        "font-weight": 640,
        fill: "var(--muted)"
      });
      i.textContent = axl(a), n.appendChild(i)
    }
  }

  function A(t) {
    ax();
    var e = k(t),
      n = g(ft2u(Wd(t) * j(t) * L(t)), 14, 1.35 * b),
      r = E(e.turn, e.fade, t.s, MIR(t), t.g);
    return {
      dist: n,
      p0: [v, y],
      p1: [v + r.x1 * n, y + r.y1 * n],
      p2: [v + r.x2 * n, y + r.y2 * n],
      p3: [v + r.x3 * n, y + r.y3 * n]
    }
  }

  function M(t) {
    return "M" + t.p0[0].toFixed(2) + "," + t.p0[1].toFixed(2) + "C" + t.p1[0].toFixed(2) + "," + t.p1[1].toFixed(2) + " " + t.p2[0].toFixed(2) + "," + t.p2[1].toFixed(2) + " " + t.p3[0].toFixed(2) + "," + t.p3[1].toFixed(2)
  }

  function B(t) {
    return (Math.round(10 * t) / 10).toString()
  }

  function H(t) {
    return t.v + "|" + t.m
  }

  function I(t) {
    return (t.v + "-" + t.m).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
  }

  function _(t) {
    return String(t).replace(/[&<>"]/g, function(t) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;"
      } [t]
    })
  }

  function T(t, e) {
    var n = document.createElementNS("http://www.w3.org/2000/svg", t);
    for (var r in e) null !== e[r] && void 0 !== e[r] && n.setAttribute(r, e[r]);
    return n
  }
  var S = {},
    F = {},
    O = {};
  e.forEach(function(t) {
    S[I(t)] = t, F[H(t)] = t, O[t.v + " " + t.m] = t
  });
  var R = {
      RHBH: {
        mirror: 1
      },
      LHFH: {
        mirror: 1
      },
      LHBH: {
        mirror: -1
      },
      RHFH: {
        mirror: -1
      }
    },
    N = "RHBH";
  var q = 175.1,
    P = 1.152,
    D = .3048;

  /* ARM-SPEED CEILING. Ryan 29 Aug: normal distances to ~speed 6-7, then
     exponential losses -- "the scale keeps going up, just small increments and
     even more fade out applied". Distance was linear in speed with arm speed as
     ONE GLOBAL SCALAR, so Destroyer/TeeBird was 1.20x at every arm alike. Both
     halves key off how far a disc outruns the player. Constants are judgement,
     not measurement -- see SESSION-29-AUG.md. */
  /* HOW REAL BAGS ARE SPACED. Measured 29 Aug 2026 from data/pro-bags.json --
     8 full touring bags, nearest-neighbour landing distance between a player's
     own discs, at their own arm speed. These replace numbers that were
     previously chosen to make one demo bag look sensible.
       median 24 ft | p25 16 | p75 38 | p90 53
     WANT is the stability a bag should aim at: pro bags average turn+fade 2.15
     against a catalogue mean of 1.10, and only one of the eight (Robinson,
     3.04) exceeds 2.4. The old cap of 3.2 told a strong-armed player to want a
     bag more overstable than any professional actually carries.
     Re-read these when bags are added; verify-pro-bags.mjs prints them. */
  var PRO = {
    NEAR: 24,   // median gap between a pro's own discs, ft
    WIDE: 53,   // p90 -- past this, "further" stops meaning "better"
    WANT: 2.4,  // most overstable a bag should ever be aimed
    NEUT: 1.1   // catalogue mean turn+fade
  };

  var CEIL = {
    on: true,
    KS: 2.5,    // most extra speed rating ever worth, in speed units
    OP: 0.075,  // how hard fade bites per speed unit over the ceiling
    GC: 0.5,    // fade a disc can express per point of glide before it lands
    TR: 0.045   // how hard the ground truncates the line beyond that
  };

  function SU() {
    return Math.max(3, Math.min(14, .0325 * U - 2.44));
  }

  function OVER(t) {
    return CEIL.on ? Math.max(0, (t.s || 0) - SU()) : 0;
  }

  /* Diminishing, never negative: a faster disc still beats a slower one, by
     less and less. Ryan's "the scale keeps going up, just small increments". */
  function SEFF(t) {
    var o = OVER(t);
    return o <= 0 ? (t.s || 0) : SU() + CEIL.KS * (1 - Math.exp(-o / CEIL.KS));
  }

  function j(t) {
    return q + P * (10 * SEFF(t) + 6 * t.g)
  }

  /* THE REFERENCE ARM, which is a constant and must read like one.
     j() is the player's own modelled distance: it runs through SEFF(), so it
     saturates against THEIR ceiling and therefore moves with the number they
     typed. The caption below is a sentence about the arm the BOX numbers
     assume -- a fixed property of the flight-number convention -- so quoting
     j(V) there made a constant claim carry a moving figure: the same sentence
     said a Destroyer goes 86 m to a 60 m arm and 106 m to a 140 m arm.
     jr() is j() with no ceiling applied, which is exactly "what this disc does
     for the arm the numbers were written for". Used for the quoted figure only;
     every distance a player actually reads still comes from j(), and the
     "well below / about the same" wording and the easiest-to-throw nudge
     still read W() exactly as they did before 10 Sep. */
  function jr(t) {
    return q + P * (10 * (t.s || 0) + 6 * t.g)
  }
  var V = null,
    U = 348,
    z = "m";

  function W() {
    return V ? U / j(V) : 1
  }

  function Y(t) {
    var e = function(t) {
      return Wd(t) * j(t) * L(t)
    }(t);
    return "m" === z ? Math.round(e * D) + " m" : Math.round(e) + " ft"
  }
  var BAGS = {
    // The example bag, Ryan's list. Twelve discs, speed 12 down to a putter.
    // Trimmed from sixteen on 22 Aug: the Ape and Max came out because opening
    // on two speed-11+ overstable bombs sets the scale by discs almost nobody
    // throws, and everything else then draws short against them. Nova, Firefly
    // and RocX3 came out as near-duplicates of shapes already in the bag, and
    // the Aviar went in -- a bag with no putter is not a bag.
    fds: ["innova-xcaliber", "innova-destroyer", "innova-invictus", "innova-firebird",
          "discmania-cd2", "innova-teebird", "innova-leopard", "innova-gator",
          "innova-roc3", "innova-mako3", "innova-toro", "innova-aviar"],
    mcbeth: ["discraft-force", "discraft-venom", "discraft-zeus", "discraft-athena", "discraft-heat", "discraft-undertaker", "discraft-buzzz", "discraft-wasp", "discraft-luna", "discraft-zone"],
    heimburg: ["innova-destroyer", "innova-teebird", "innova-eagle", "innova-firebird", "innova-roc3", "innova-roc", "innova-caiman", "innova-toro", "innova-aviar", "innova-aviarx3", "innova-rhyno"],
    // The Innova Premium (GStar) 3-disc pack, exactly as it is sold: putter,
    // fairway, distance. A LOADER, not a default -- 7 Sep. The picker briefly
    // offered this set as suggestions on an empty bag and Ryan killed it: this
    // chart is for advanced players comparing discs, not for prescribing a
    // first bag. As a button it earns its place -- it is the bag everyone
    // started from, so it is the thing people compare against.
    starter: ["innova-aviar", "innova-leopard3", "innova-valkyrie"]
  };
  var Q = [],
    X = {},
    FO = 0;

  function $(t) {
    return X.hasOwnProperty(H(t))
  }
  var J = {
      by: "s",
      dir: -1
    },
    K = null;

  function tt(t) {
    var e = fdisc();
    return e && TK(e) === TK(t) ? "var(--acc)" : "var(--muted)"
  }

  function tt2(t) {
    var e = fdisc();
    return e && TK(e) === TK(t) ? "var(--acc)" : "var(--ink)"
  }

  function SL(m, thr) {
    var o = Object.create(m);
    return o.__thr = thr || N, o
  }

  function TK(t) {
    return H(t) + "|" + (t.__thr || N)
  }

  function OTH(thr) {
    return thr.slice(0, 2) + ("BH" === thr.slice(2) ? "FH" : "BH")
  }

  function hasSlot(k) {
    for (var i = 0; i < Q.length; i++)
      if (TK(Q[i]) === k) return !0;
    return !1
  }
  // X stays MOULD-keyed (every "is this disc bagged" check depends on that),
  // but is now a COUNT, so removing one slot of a twice-bagged mould keeps it set.
  function reX() {
    X = {}, Q.forEach(function(d) {
      X[H(d)] = (X[H(d)] || 0) + 1
    })
  }

  function addM(m, thr) {
    var sl = SL(m, thr);
    return !hasSlot(TK(sl)) && (Q.push(sl), reX(), !0)
  }

  function redraw() {
    DOAN = !0, it(), ct(), Et(), It(), Vt()
  }

  function setThrow(t, thr) {
    (t.__thr || N) !== thr && (hasSlot(H(t) + "|" + thr) || (t.__thr = thr, redraw()))
  }

  function dupSlot(t) {
    var o = OTH(t.__thr || N);
    hasSlot(H(t) + "|" + o) || (Q.splice(Q.indexOf(t) + 1, 0, SL(t, o)), reX(), redraw())
  }

  function nt(t) {
    var e = H(t),
      slot = Object.prototype.hasOwnProperty.call(t, "__thr"),
      n = -1;
    if (slot) {
      var k = TK(t);
      Q.forEach(function(d, r) {
        TK(d) === k && (n = r)
      }), n >= 0 && Q.splice(n, 1)
    } else {
      var had = Q.some(function(d) {
        return H(d) === e
      });
      had ? Q = Q.filter(function(d) {
        return H(d) !== e
      }) : Q.push(SL(t, N))
    }
    reX(), FO >= Q.length && FO && FO--, redraw()
  }

  function rt(t) {
    nt(t)
  }

  function loadBag(t) {
    Q = [], X = {}, FO = 0, (BAGS[t] || []).forEach(function(t) {
      var e = S[t];
      e && addM(e)
    }), DOAN = !0, it(), ct(), Et(), It(), Vt(), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-preset button"), function(e) {
      e.setAttribute("aria-pressed", e.getAttribute("data-bag") === t ? "true" : "false")
    });
    var e = document.getElementById("fdsFieldH");
    e && e.scrollIntoView({
      block: "start",
      behavior: "smooth"
    })
  }
  /* Published so the picker ranks by the SAME stability target rather than
     inventing a second one that drifts. Read live, because the slider moves. */
  window.__FDS_POWER__ = {
    ft: function () { return U; },
    wantStab: function () { return Math.max(0, Math.min(PRO.WANT, (U - 250) / 70)); }
  };
  var GK = "",
    GC = [],
    TGT = null;

  /* Brand weight = how many drawn moulds a brand has. brands.js publishes the
     same ranking, but it loads AFTER this file, so reading it here would make
     the first paint rank differently from every render after it. One pass over
     the dataset costs nothing and keeps chart.js standing on its own. */
  var BW = {};
  e.forEach(function(t) {
    null !== t.s && void 0 !== t.s && null !== t.tu && (BW[t.v] = (BW[t.v] || 0) + 1)
  });

  /* Suggestions are the BEST disc, never the in-stock disc (Ryan, 29 Aug).
     The old `stock > 0` gate dropped candidates outright -- only 103 of 1,614
     moulds carry stock, so it silently picked from 6% of the catalogue and
     returned NOTHING on a manufacturer tenant. Out-of-stock is demand signal.
     Two modes: no target = furthest from what the bag covers; a tapped target
     = nearest to that spot. Split from the renderer because the viewBox is
     fitted before drawing and a suggestion must be able to widen it. */
  function gcalc() {
    var key = (TGT ? "T" + TGT.x.toFixed(1) + "," + TGT.y.toFixed(1) : "B") + "|" +
      Q.map(TK).join(",") + "|" + W() + "|" + N + "|" + z + "|" + Math.round(10 * w) + "|" + FHR;
    if (key === GK) return;
    GK = key, GC = [];
    /* The four-disc floor exists so an empty bag is not told what it is
       missing before it has said anything. A tapped target IS the visitor
       saying something, so the floor does not apply to it. */
    if (!TGT && Q.length < 4) return;
    var ARC = [];
    Q.forEach(function(t) {
      [-1, -.5, 0, .5, 1].forEach(function(o) {
        ARC.push(LPo(t, o))
      })
    });
    var cand = [];
    /* Arm-speed gate: do not recommend a disc the player cannot turn over. The
     chart draws a Very-high-arm driver honestly for a 250 ft player -- short,
     fading early -- and that landing point can sit in a hole. `as` is derived
     from speed and lossy; the ceiling now models this better, so this gate is
     a candidate for deletion. Thresholds are invented. */
    var AST = U >= 400 ? 4 : U >= 330 ? 3 : U >= 250 ? 2 : 1,
      ASR = {
        Any: 0,
        Low: 1,
        Moderate: 2,
        High: 3,
        "Very high": 4
      };
    e.forEach(function(t) {
      if ($(t) || t.s === null || t.s === void 0 || t.tu === null) return;
      if (t.as && (ASR[t.as] || 0) > AST) return;
      var q3 = A(t),
        ex = q3.p3[0],
        ey = q3.p3[1];
      if (TGT) return void cand.push({
        d: t,
        x: ex,
        y: ey,
        gap: u2ft(Math.hypot(ex - TGT.x, ey - TGT.y))
      });
      var bs = 1e9;
      ARC.forEach(function(p) {
        var dd = Math.hypot(ex - p[0], ey - p[1]);
        dd < bs && (bs = dd)
      });
      cand.push({
        d: t,
        x: ex,
        y: ey,
        gap: u2ft(bs)
      })
    });
    /* Fit alone is not a recommendation. The stock gate was doing the quality
     work by accident; without it the widest gap is won by long-tail oddities.
     Fit is bucketed and saturating so shape and provenance can decide. */
    var bagBrands = {};
    Q.forEach(function(t) {
      bagBrands[t.v] = 1
    });
    var CONF = {
      manufacturer: 0,
      fds: 0,
      retailer: 1,
      aggregator: 2
    };

    function cf(d) {
      var r = CONF[d.src];
      return void 0 === r ? 3 : r
    }
    /* FIT SATURATES. A disc landing 120 ft from anything you own is not twice
       as useful as one landing 60 ft away -- both fill the hole, and past that
       point "further from your bag" just means "stranger disc". Ten-foot
       buckets let a four-foot advantage beat a mould the player has heard of,
       which is how an unLace and a Tiyanak reached the first screen. Cap the
       benefit, coarsen the bucket, and let the quality order below decide
       among everything that genuinely fills the gap. */
    /* MEASURED, 29 Aug 2026, against the 8 full pro bags: the discs in a real
       bag sit a median 24 ft apart, p25 16, p75 38, p90 53. So the saturation
       point is the p90 -- "a gap wider than a professional tolerates between
       his own discs" -- rather than the 60 ft I first guessed, which sat a
       whole step beyond where real bags stop caring. Buckets follow the
       quartile width. */
    function fit(g) {
      return TGT ? Math.round(g / 8) : Math.round(Math.min(g, PRO.WIDE) / 13)
    }
    /* Stability follows the power slider (Ryan, 29 Aug: right = more overstable).
     The tail of this comparator used to read `a.f - b.f`, which is this rule
     with the slider welded to one end. NOT applied to fit: the chart already
     re-renders flight from arm speed, so biasing fit too would correct twice.
     Separate axis from the arm-speed gate -- that asks "can they throw it",
     this asks "which shape suits them". */
    /* Rank on intent, not on where it lands (Ryan: "for the slider we shouldn't
     consider the disc hitting the ground"). Truncation is asymmetric, so while
     fit ranked before shape it dragged overstable discs out of contention and
     the trend went flat. Ranking on un-truncated LANDING points was rejected --
     that recommends a disc for a gap its drawn flight visibly misses. */
    var WANT = window.__FDS_POWER__.wantStab();

    function sfit(d) {
      return Math.abs((d.tu + d.f) - WANT)
    }
    cand.sort(function(a, b) {
      var qa = bagBrands[a.d.v] ? 0 : 1,
        qb = bagBrands[b.d.v] ? 0 : 1;
      if (qa !== qb) return qa - qb;
      /* FIT QUALIFIES; STABILITY RANKS. The fit bucket used to do both jobs,
         and that is why the slider went quiet: a disc had to win on gap size
         before its shape was ever considered. But take() already enforces the
         floor -- every candidate reaching this comparator genuinely fills a
         hole a pro would call open. Among discs that all clear that bar, the
         one that suits the player's arm is the better recommendation, and gap
         size beyond the floor is precisely the thing measurement showed
         saturates. So shape leads and gap breaks its ties. */
      var sa = Math.round(sfit(a.d) * 2),
        sb = Math.round(sfit(b.d) * 2);
      if (sa !== sb) return sa - sb;
      var fa = fit(a.gap),
        fb = fit(b.gap);
      if (fa !== fb) return TGT ? fa - fb : fb - fa;
      var ca = cf(a.d),
        cb = cf(b.d);
      if (ca !== cb) return ca - cb;
      var ra = BW[b.d.v] || 0,
        rb2 = BW[a.d.v] || 0;
      if (ra !== rb2) return ra - rb2;
      return (b.d.g - a.d.g) || (a.d.s - b.d.s) || a.d.m.localeCompare(b.d.m)
    });
    /* Spread the picks out so five markers are five ANSWERS rather than five
       names for one spot. Tighter inside a target, because there the whole
       point is that they all land near the same place. */
    /* Feet-based thresholds starve weak arms: a 213 ft player had 768 valid
     candidates and ONE surviving suggestion. Both scale with the arm. */
    /* A short-disc floor was tried here and REVERTED -- do not re-add. Theory was
     that the Sonic kept appearing because it lands under the bag's shortest
     disc. Measured: 63 m vs the Aviar's 69. It is not short, it is WIDE, and it
     fills a real hole nothing else was filling. */
    /* The floor was 20 ft, which passed gaps TIGHTER than a quarter of all
       real disc pairings -- offering a disc into space a pro would call
       already covered. It is now the measured median. Separation stays at
       35 ft: it sits between p25 and p75, and is the first of these constants
       to survive contact with data. */
    var PS = Math.max(.45, Math.min(1.6, U / 348)),
      SEP = (TGT ? 16 : 35) * PS,
      FLOOR = PRO.NEAR * PS;

    function take(t) {
      if (TGT ? t.gap > TGT.ft : t.gap < FLOOR) return false;
      for (var i2 = 0; i2 < GC.length; i2++)
        if (u2ft(Math.hypot(GC[i2].x - t.x, GC[i2].y - t.y)) < SEP) return false;
      return GC.push(t), true
    }
    if (TGT) {
      /* Inside a target every pick answers the same question, so band spread
         would be wrong here -- if three putters land where you tapped, three
         putters is the honest answer. */
      cand.forEach(function(t) {
        GC.length < 5 && take(t)
      })
    } else {
      /* ONE PASS PER BAND BEFORE A SECOND FROM ANY BAND -- the picker's rule,
         which the bouquet never had. Without it five gap-ranked picks can be
         five distance drivers, or two putters and nothing between; the bag is
         then told about one shot five times. Walking outward from the basket
         matches the picker exactly, so the two engines recommend in the same
         order as well as by the same measure. */
      var BO = ["PA", "MR", "FD", "DD"],
        used = {};
      for (var r2 = 0; r2 < 5 && GC.length < 5; r2++)
        for (var bi = 0; bi < BO.length && GC.length < 5; bi++)
          for (var ci = 0; ci < cand.length; ci++) {
            var cc = cand[ci];
            if (used[ci] || BND(cc.d) !== BO[bi]) continue;
            if (take(cc)) {
              used[ci] = 1;
              break
            }
            used[ci] = 1
          }
    }
  }

  function gaps(sv, lbl, c) {
    var GN = document.getElementById("fdsGapNote");
    if (!GN) return;
    if (!TGT && Q.length < 4) return void(GN.innerHTML = "Add 4 or more discs to get suggestions.");
    /* The target reads as a place on the field, not as a control. It is drawn
       under everything so a marker sitting on it is never obscured. */
    if (TGT) sv.appendChild(T("circle", {
      cx: TGT.x,
      cy: TGT.y,
      r: ft2u(TGT.ft),
      fill: "var(--gapc)",
      "fill-opacity": .07,
      stroke: "var(--gapc)",
      "stroke-width": 1.2 * c,
      "stroke-opacity": .55,
      "stroke-dasharray": (3 * c).toFixed(2) + " " + (3 * c).toFixed(2)
    }));
    GC.forEach(function(t2) {
      /* A suggestion has to show its flight, or a flippy disc is just a name in
         empty space. Carried by the gap COLOUR, never a dash: dashed means
         forehand here and verify-forehand-styling.mjs asserts it. */
      sv.appendChild(T("path", {
        d: M(A(t2.d)),
        fill: "none",
        stroke: "var(--gapc)",
        "stroke-width": 1.6 * c,
        "stroke-opacity": .5,
        "stroke-linecap": "round"
      }));
      var e2 = T("circle", {
        class: "fdsfc-bqsug",
        cx: t2.x,
        cy: t2.y,
        r: 5.2 * c,
        fill: "var(--field-grass)",
        stroke: "var(--gapc)",
        "stroke-width": 1.9 * c,
        "stroke-dasharray": (2.8 * c).toFixed(2) + " " + (2.1 * c).toFixed(2)
      });
      e2.addEventListener("click", function() {
        Ht(), nt(t2.d)
      });
      e2.addEventListener("mousemove", function(n2) {
        Bt.innerHTML = "<b>" + _(t2.d.m) + "</b> &nbsp;<i>" + _(t2.d.v) + "</i><br><i>" + (TGT ? "lands where you tapped" : "a shape your bag does not have yet") + " — tap to add it</i>", Bt.style.left = n2.clientX + "px", Bt.style.top = n2.clientY + "px", Bt.style.opacity = "1"
      });
      e2.addEventListener("mouseleave", Ht), sv.appendChild(e2), lbl.push({
        t: t2.d.m,
        c: "var(--gapc)",
        fs: 11,
        x: t2.x,
        y: t2.y,
        right: t2.x >= v
      })
    });
    var mn = 1e9,
      mx = -1e9;
    Q.forEach(function(t) {
      var f = u2ft(A(t).p3[0] - v);
      f < mn && (mn = f), f > mx && (mx = f)
    });

    function sf(f) {
      var n2 = "m" === z ? Math.round(f * D) : Math.round(f);
      return (n2 > 0 ? "+" : "") + n2 + ("m" === z ? " m" : " ft")
    }

    function rd(f) {
      return "m" === z ? Math.round(Math.abs(f) * D) : Math.round(Math.abs(f))
    }

    function un() {
      return "m" === z ? " m" : " ft"
    }
    var L = rd(mn),
      Rr = rd(mx),
      SPAN = "m" === z ? Math.round((mx - mn) * D) + " m" : Math.round(mx - mn) + " ft";

    // Read as instruments, not prose. The moulds that fall outside the spread
    // are already drawn as dashed markers, so naming them here just repeats
    // the chart; the caption points at them instead.
    function stat(k, val, warn) {
      return '<span class="fdsfc-gapstat' + (warn ? " is-warn" : "") + '"><i>' + k + "</i><b>" + val + "</b></span>"
    }
    /* TARGET MODE ANSWERS A DIFFERENT QUESTION, so it gets a different
       readout. The spread stats describe a bag; they say nothing about a spot
       the visitor pointed at. */
    if (TGT) {
      var trow = stat("Target", sf(u2ft(TGT.x - v)) + " / " + rd(u2ft(y - TGT.y)) + un()) +
        stat("Within", rd(TGT.ft) + un()) +
        stat("Matches", GC.length || "none", !GC.length);
      GN.innerHTML = '<div class="fdsfc-gaprow">' + trow + '</div><p class="fdsfc-gapcap">' +
        (GC.length ?
          "Discs that finish where you tapped, each drawn with its flight. Tap one to add it." :
          "Nothing finishes there at this arm speed. Tap somewhere closer in, or raise the distance above.") +
        ' <button type="button" class="fdsfc-gapclear">Clear target</button></p>';
      var cb = GN.querySelector(".fdsfc-gapclear");
      cb && cb.addEventListener("click", function() {
        TGT = null, it()
      });
      return
    }
    var row = stat("Discs", Q.length) + stat("Spread", SPAN) +
      stat("Left", L ? L + un() : "none", !L) +
      stat("Right", Rr ? Rr + un() : "none", !Rr) +
      stat("Outside", GC.length || "none");
    /* "discs we stock" was the retailer assumption leaking into copy: on a
       manufacturer tenant the sentence is simply false. The markers describe
       themselves now that they carry a flight path. */
    var cap = Rr ? L ? GC.length ? "Ringed discs would finish outside your spread — each is drawn with the flight it would take. Tap one to try it, or tap anywhere on the field to ask what lands there." : "Nothing obvious is missing from your spread. Tap anywhere on the field to ask what lands there." : "Everything finishes right of the tee line — nothing in the bag hooks back." : "Nothing finishes right of the tee line — you have no understable line.";
    GN.innerHTML = '<div class="fdsfc-gaprow">' + row + '</div><p class="fdsfc-gapcap">' + cap + "</p>"
  }
  var at = document.getElementById("fdsField"),
    ot = document.getElementById("fdsEmpty");

  function it() {
    DR = [];
    for (; at.firstChild;) at.removeChild(at.firstChild);
    ot.hidden = Q.length > 0;
    ax();
    var px = at.parentNode.clientWidth || 640,
      py = at.parentNode.clientHeight || 420,
      asp = px / py,
      lo = v,
      hi = v,
      c0 = 231 / py;

    function grow(t) {
      var e = A(t);
      [e.p0[0], e.p1[0], e.p2[0], e.p3[0]].forEach(function(t) {
        t < lo && (lo = t), t > hi && (hi = t)
      });
      var n = (5.4 * t.m.length + 16) * c0;
      e.p3[0] >= v ? hi = Math.max(hi, e.p3[0] + n) : lo = Math.min(lo, e.p3[0] - n)
    }
    Q.forEach(grow);
    if (K && !X.hasOwnProperty(K)) {
      var gh = F[K];
      gh && grow(gh)
    }
    /* Suggestions are computed HERE, before the frame is fitted, because they
       now draw a full flight rather than a lone dot. A Roadrunner suggested to
       a bag of overstable drivers finishes well outside that bag's spread, and
       fitting the frame to the bag alone would run its arc off the canvas --
       which is exactly the disc the visitor most needs to see. */
    gcalc();
    GC.forEach(function(t) {
      grow(t.d)
    });
    var need = hi - lo + 40 * c0,
      bh = 231,
      bw = bh * asp;
    bw < need && (bh = (bw = need) / asp);
    var t = {
        x: (lo + hi) / 2 - bw / 2,
        y: y - (bh - 26),
        w: bw,
        h: bh
      },
      c = t.w / px;
    at.setAttribute("viewBox", t.x.toFixed(1) + " " + t.y.toFixed(1) + " " + t.w.toFixed(1) + " " + t.h.toFixed(1));
    var g0 = T("g", {}),
      step = 23.125;
    for (var q = Math.ceil(t.x / step) * step; q < t.x + t.w; q += step) g0.appendChild(T("line", {
      x1: q,
      y1: t.y,
      x2: q,
      y2: t.y + t.h,
      stroke: "var(--field-line)",
      "stroke-width": .7 * c,
      "stroke-opacity": .5
    }));
    Ax(g0, t, c);
    g0.appendChild(T("line", {
      x1: v,
      y1: y,
      x2: v,
      y2: t.y,
      stroke: "var(--muted)",
      "stroke-width": 1.1 * c,
      "stroke-opacity": .45,
      "stroke-dasharray": (4 * c).toFixed(2) + " " + (5 * c).toFixed(2)
    }));
    g0.appendChild(T("rect", {
      x: v - 11 * c,
      y: y + 2 * c,
      width: 22 * c,
      height: 6 * c,
      rx: 2 * c,
      fill: "var(--field-line)"
    }));
    var tee = T("text", {
      x: v,
      y: y + 20 * c,
      "text-anchor": "middle",
      "font-size": 10 * c,
      fill: "var(--muted)",
      "letter-spacing": (.9 * c).toFixed(2)
    });
    tee.textContent = "TEE", g0.appendChild(tee), at.appendChild(g0);
    if (K && !X.hasOwnProperty(K)) {
      var gh2 = F[K];
      gh2 && at.appendChild(T("path", {
        d: M(A(gh2)),
        fill: "none",
        stroke: "var(--muted)",
        "stroke-width": 2.6 * c,
        "stroke-opacity": .34,
        "stroke-linecap": "round",
        "stroke-dasharray": (5 * c).toFixed(2) + " " + (5 * c).toFixed(2)
      }))
    }
    var lbl = [],
      HIT = [];
    Q.forEach(function(t) {
      var e = A(t),
        n = tt(t);
      var fd = fdisc(),
        isF = !!fd && TK(fd) === TK(t);
      var fh = isFH(t);
      var pth = T("path", {
        d: M(e),
        fill: "none",
        stroke: n,
        "stroke-width": (isF ? 4.6 : 2) * c,
        "stroke-linecap": "round",
        "stroke-dasharray": fh ? (7.5 * c).toFixed(2) + " " + (5.5 * c).toFixed(2) : null,
        "stroke-opacity": isF ? 1 : .6
      });
      at.appendChild(pth), DR.push(pth);
      at.appendChild(T("circle", {
        cx: e.p3[0],
        cy: e.p3[1],
        r: (isF ? 6.8 : 4) * c,
        fill: fh ? "var(--field-grass)" : n,
        stroke: fh ? n : "var(--field-grass)",
        "stroke-width": (fh ? 2.2 : 1.7) * c
      }));
      var hp = T("path", {
        class: "fdsfc-hitp",
        d: M(e),
        fill: "none",
        stroke: "transparent",
        "stroke-width": 16 * c,
        "stroke-linecap": "round"
      });
      hp.addEventListener("click", function() {
        setFocus(t)
      });
      HIT.push({
        h: hp,
        f: isF
      });
      lbl.push({
        t: t.m + (X[H(t)] > 1 ? " " + (t.__thr || N).slice(2) : ""),
        d: Y(t),
        focus: isF,
        c: isF ? "var(--ink)" : "var(--muted)",
        fw: isF ? 800 : 650,
        fs: isF ? 13.2 : 9.4,
        x: e.p3[0],
        y: e.p3[1],
        right: e.p3[0] >= v
      })
    });
    gaps(at, lbl, c);
    bqlbl(at, lbl, c);
    HIT.sort(function(t, e) {
      return (e.f ? 1 : 0) - (t.f ? 1 : 0)
    }).forEach(function(t) {
      at.appendChild(t.h)
    });
    /* TAP THE FIELD TO ASK WHAT LANDS THERE.
       No new control, no new words. The player who wants a flippy disc does
       not know to search "understable" -- but they can point at the spot right
       of the fairway where they want the disc to finish, and this answers in
       the only vocabulary the chart has ever used: where it ends up.

       The hit layer goes on LAST so it sits above the field, but the disc
       flight paths and the markers are re-appended after it, so tapping a
       disc still selects the disc rather than dropping a target on it. */
    var hitr = T("rect", {
      x: t.x,
      y: t.y,
      width: t.w,
      height: t.h,
      fill: "transparent",
      class: "fdsfc-bqfield"
    });
    hitr.addEventListener("click", function(ev) {
      var pt = at.createSVGPoint ? at.createSVGPoint() : null;
      if (!pt) return;
      pt.x = ev.clientX, pt.y = ev.clientY;
      var m = at.getScreenCTM();
      if (!m) return;
      var p = pt.matrixTransform(m.inverse());
      /* A ring rather than a point: nobody taps within a foot of anything, and
         a radius is what makes "near here" answerable. 45 ft is about a
         putt-and-a-half -- tight enough to mean a place, wide enough to
         return more than one disc. */
      TGT = {
        x: p.x,
        y: p.y,
        ft: 45
      }, Ht(), it()
    });
    at.insertBefore(hitr, at.firstChild ? at.firstChild.nextSibling : null);
    AN()
  }
  var DR = [],
    DOAN = !1,
    ANOK = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  function AN() {
    if (!DOAN) return void(DR = []);
    if (DOAN = !1, !ANOK || !DR.length || !DR[0].getTotalLength) return void(DR = []);
    DR.forEach(function(p, i) {
      var L2 = 0;
      try {
        L2 = p.getTotalLength()
      } catch (e) {}
      if (!L2) return;
      var da = p.getAttribute("stroke-dasharray");
      p.animate([{
        strokeDasharray: L2 + " " + L2,
        strokeDashoffset: L2
      }, {
        strokeDasharray: L2 + " " + L2,
        strokeDashoffset: 0
      }], {
        duration: 720,
        delay: 90 * i,
        easing: "cubic-bezier(.12,.72,.28,1)"
      }).onfinish = function() {
        da ? p.setAttribute("stroke-dasharray", da) : p.removeAttribute("stroke-dasharray")
      };
      p.setAttribute("stroke-dasharray", L2 + " " + L2)
    });
    DR = []
  }
  var st = document.getElementById("fdsSlots"),
    dt = document.getElementById("fdsClear"),
    lt = document.getElementById("fdsCopy"),
    RB = document.getElementById("fdsResetBag");
  RB && RB.addEventListener("click", function() {
    loadBag("fds")
  });
  var CNUM = document.getElementById("fdsCanvasNum");
  var FHI = document.getElementById("fdsFHRatio");
  FHI && FHI.addEventListener("input", function() {
    var v = parseInt(FHI.value, 10);
    v >= 50 && v <= 150 && (FHR = v / 100, AX.key = "", DOAN = !0, it(), ct(), Et(), It(), Vt())
  });
  var HE = document.getElementById("fdsHero"),
    FR = document.getElementById("fdsFocus");

  function fdisc() {
    return Q.length ? Q[Math.min(FO, Q.length - 1)] : null
  }

  function setFocus(t) {
    var e = H(t),
      n = -1;
    Q.forEach(function(t, r) {
      H(t) === e && (n = r)
    });
    n < 0 || n === Math.min(FO, Q.length - 1) || (FO = n, ct(), It(), it())
  }

  function focusRow() {
    FR && (FR.innerHTML = "")
  }

  function hero() {
    if (!HE) return;
    var fd = fdisc();
    if (!fd) return CNUM && (CNUM.hidden = !0), void(HE.innerHTML = '<p class="fdsfc-hero__none">Pick a disc to draw its flight</p>');
    var t = fd;
    HE.style.setProperty("--c", tt(t));
    CNUM && (CNUM.innerHTML = "<b>" + Y(t).replace(/ (ft|m)$/, "") + "</b><i>" + ("m" === z ? "M" : "FT") + "</i>", CNUM.hidden = !1);
    HE.innerHTML = '<div class="fdsfc-hero__nm">' + _(t.m) + '</div><div class="fdsfc-hero__mt">' + _(t.v) + " &middot; " + _(r[t.t]) + " &middot; " + _(t.st) + '</div><div class="fdsfc-hero__f">' + [
      ["SP", B(t.s)],
      ["GL", B(t.g)],
      ["TU", B(t.tu)],
      ["FA", B(t.f)],
      ["DIST", Y(t)]
    ].map(function(p, i) {
      return '<div' + (4 === i ? ' class="is-dist"' : "") + "><i>" + p[0] + "</i><b>" + p[1] + "</b></div>"
    }).join("") + "</div>"
  }

  function ct() {
    focusRow(), hero(), st.innerHTML = "", Q.forEach(function(t) {
      var e = document.createElement("div");
      e.className = "fdsfc-slot", e.style.setProperty("--c", tt(t));
      var isF = !!fdisc() && TK(fdisc()) === TK(t);
      var thr = t.__thr || N,
        hand = thr.slice(0, 2),
        isBH = "BH" === thr.slice(2),
        pill = '<div class="fdsfc-slotthrow" role="group" aria-label="Throw for ' + _(t.m) + '">' +
        '<button type="button" data-thr="' + hand + 'BH" aria-pressed="' + (isBH ? "true" : "false") + '">BH</button>' +
        '<button type="button" data-thr="' + hand + 'FH" aria-pressed="' + (isBH ? "false" : "true") + '">FH</button>' +
        (hasSlot(H(t) + "|" + OTH(thr)) ? "" : '<button type="button" class="fdsfc-slotdup" aria-label="Also draw ' + _(t.m) + ' ' + (isBH ? "forehand" : "backhand") + '" title="Also draw it ' + (isBH ? "forehand" : "backhand") + '">+</button>') +
        "</div>";
      e.innerHTML = '<div class="fdsfc-slot__body"><div class="fdsfc-slot__hd"><button class="fdsfc-slot__nm" type="button" aria-pressed="' + (isF ? "true" : "false") + '"><span class="fdsfc-slot__name">' + _(t.m) + '</span></button><span class="fdsfc-slot__n">' + B(t.s) + " / " + B(t.g) + " / " + B(t.tu) + " / " + B(t.f) + '</span><button class="fdsfc-slot__car" type="button" aria-expanded="false" aria-label="More about ' + _(t.m) + '">&#9662;</button></div>' + pill + '<div class="fdsfc-slot__more" hidden><div class="fdsfc-slot__meta">' + _(t.v) + " &middot; " + _(r[t.t]) + " &middot; " + _(t.st) + '</div><div class="fdsfc-slot__nums">' + ("≈ <b>" + Y(t) + "</b> for you") + '</div></div></div><button class="fdsfc-slot__x" type="button" aria-label="Remove ' + _(t.m) + '">&times;</button>';
      var mo = e.querySelector(".fdsfc-slot__more"),
        cr = e.querySelector(".fdsfc-slot__car");
      cr.addEventListener("click", function() {
        var o = mo.hidden;
        mo.hidden = !o, cr.setAttribute("aria-expanded", o ? "true" : "false")
      }), Array.prototype.forEach.call(e.querySelectorAll(".fdsfc-slotthrow button[data-thr]"), function(btn) {
        btn.addEventListener("click", function() {
          setThrow(t, btn.getAttribute("data-thr"))
        })
      }), function() {
        var dp = e.querySelector(".fdsfc-slotdup");
        dp && dp.addEventListener("click", function() {
          dupSlot(t)
        })
      }(), e.querySelector(".fdsfc-slot__nm").addEventListener("click", function() {
        setFocus(t)
      }), e.querySelector(".fdsfc-slot__x").addEventListener("click", function() {
        nt(t)
      });
      var n = (t.cmp || []).map(function(t) {
        return O[t]
      }).filter(Boolean);
      if (n.length) {
        var a = document.createElement("div");
        a.className = "fdsfc-cmp", a.innerHTML = '<span class="fdsfc-cmp__lbl">Flies like</span>', n.forEach(function(t) {
          var e = document.createElement("button");
          e.type = "button", e.className = "fdsfc-chip", e.textContent = t.m, e.title = t.m + " · " + t.v, X.hasOwnProperty(H(t)) && (e.disabled = !0), e.addEventListener("click", function() {
            nt(t)
          }), a.appendChild(e)
        }), mo.appendChild(a)
      }
      st.appendChild(e)
    });
    dt.hidden = 0 === Q.length, lt.hidden = 0 === Q.length, RB && (RB.hidden = function() {
      var a = Q.map(I).sort().join(","),
        b = BAGS.fds.slice().sort().join(",");
      return a === b
    }())
  }
  dt.addEventListener("click", function() {
    Q = [], X = {}, FO = 0, Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-preset button"), function(t) {
      t.setAttribute("aria-pressed", "false")
    }), it(), ct(), Et(), It(), Vt()
  });
  lt.addEventListener("click", function() {
    var t = location.href;
    navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(t).then(function() {
      lt.textContent = "Link copied", setTimeout(function() {
        lt.textContent = "Copy link to this comparison"
      }, 1600)
    }, function() {
      prompt("Copy this link:", t)
    }) : prompt("Copy this link:", t)
  });
  var ut, ft = document.getElementById("fdsQ"),
    ht = document.getElementById("fdsBrand"),
    pt = document.getElementById("fdsType"),
    mt = document.getElementById("fdsStab"),
    vt = document.getElementById("fdsArm"),
    yt = document.getElementById("fdsStock"),
    bt = document.getElementById("fdsList"),
    gt = document.getElementById("fdsCount");

  /* THE LIST IS BUILT ON FIRST OPEN, NOT ON LOAD.
     #fdsListWrap ships hidden behind "Browse the full list", and the panel copy
     says the search above the bag is usually quicker -- so the catalogue is the
     secondary path. Building it anyway cost 1,614 rows / ~37,000 DOM nodes on
     every page load, 85% of the page, for a list most visitors never open.

     Et() still computes the filtered set and still writes #fdsCount. That write
     is kept because it is one small element against 37,000 nodes, and because
     leaving Et() with a single unconditional contract -- "the count always
     matches the filters" -- is worth more than the bytes. Note the count lives
     INSIDE the wrap, as do the six filters and the sort bar; nothing in there is
     reachable while closed.

     listStale therefore means "something outside the disclosure moved while we
     were closed" -- the distance slider, the reference mould, units, the bag,
     the easiest-to-throw button -- all of which change what a row reads. It is
     what makes reopening rebuild instead of showing rows that disagree with the
     count directly above them. */
  var listShown = !1,
    listStale = !0;

  /* AND ONCE ASKED FOR, IT IS DRAWN IN CHUNKS.
     1,614 rows is still 37,122 nodes in one synchronous burst. PAGE rows go in
     first; the rest follow as a sentinel scrolls towards view.

     50 is about four screens of the 620px desktop list, which matters for more
     than feel: an IntersectionObserver fires on a CHANGE of state, so a chunk
     too small to push the sentinel back out of view would fire once and then
     stall. Every draw has to move it.

     AN IntersectionObserver WAS TRIED FIRST AND IS THE WRONG TOOL HERE, for two
     reasons that only show up in this layout. With the viewport as root it
     never fires while the list sits below the fold -- which is where it always
     sits, since the flight paths come first -- so scrolling the list's own
     scroller drew nothing. With #fdsList as root it stalls on the mobile
     layout instead: an observer reports CHANGES of state, and a sentinel that
     is simply always visible inside a non-scrolling container is not a change.

     So the trigger is measured directly, against the INTERSECTION of the
     viewport and #fdsList's own box. That is the one test that is right in both
     layouts: the list is its own scroller on desktop (max-height:620px) and
     hands scrolling back to the page under 760px (max-height:none). */
  var PAGE = 50,
    listRows = [],
    listDrawn = 0,
    listMore = null;

  function moreNear() {
    if (!listMore || !listMore.parentNode) return !1;
    var s = listMore.getBoundingClientRect(),
      c = bt.getBoundingClientRect(),
      vh = window.innerHeight || document.documentElement.clientHeight,
      top = Math.max(c.top, 0),
      bot = Math.min(c.bottom, vh);
    return bot > top && s.top <= bot + 600
  }

  /* Tops up until the sentinel is out of reach again, so a container taller
     than one chunk fills in one pass instead of one chunk per scroll event.
     The guard is a belt for a bug, not for the data -- listDrawn only ever
     advances, so the loop is already bounded by the row count. */
  function listTick() {
    for (var g = 0; listDrawn < listRows.length && moreNear() && g < 200; g++) drawMore()
  }

  function ensureMore() {
    if (listMore) return;
    listMore = document.createElement("div"), listMore.className = "fdsfc-more",
      listMore.setAttribute("aria-hidden", "true"),
      /* A zero-height box is a poor thing to measure; give it a pixel. */
      listMore.style.height = "1px",
      bt.addEventListener("scroll", listTick, {
        passive: !0
      }), window.addEventListener("scroll", listTick, {
        passive: !0
      }), window.addEventListener("resize", listTick, {
        passive: !0
      })
  }

  function hideMore() {
    listMore && listMore.parentNode && listMore.parentNode.removeChild(listMore)
  }

  function mkRow(t) {
    var e = H(t),
      n = X.hasOwnProperty(e),
      o = document.createElement("div");
    o.className = "fdsfc-rowwrap", o.id = "m-" + I(t), n && (o.setAttribute("data-sel", ""), o.style.setProperty("--c", "var(--acc)"));
    var i = document.createElement("button");
    i.type = "button", i.className = "fdsfc-row", i.setAttribute("aria-pressed", n ? "true" : "false"), i.innerHTML = '<span class="fdsfc-row__dot"></span><span class="fdsfc-row__id"><span class="fdsfc-row__mold">' + _(t.m) + '</span><span class="fdsfc-row__sub">' + _(t.v) + " &middot; " + _(r[t.t]) + (t.n > 1 ? " &middot; " + t.n + " listings" : "") + '</span></span><span class="fdsfc-nums"><span class="fdsfc-num n-s"><i>Sp</i><b>' + B(t.s) + '</b></span><span class="fdsfc-num n-g"><i>Gl</i><b>' + B(t.g) + '</b></span><span class="fdsfc-num n-t"><i>Tu</i><b>' + B(t.tu) + '</b></span><span class="fdsfc-num n-f"><i>Fa</i><b>' + B(t.f) + '</b></span></span><span class="fdsfc-dist">' + Y(t) + '</span><span class="fdsfc-stab">' + _(t.st) + '</span><span class="fdsfc-stock"' + (t.stock > 0 ? "" : " data-out") + ' title="' + (t.stock > 0 ? "In stock" : "Out of stock") + '"></span>', i.addEventListener("click", function() {
      nt(t)
    }), i.addEventListener("mouseenter", function() {
      K = e, it()
    }), i.addEventListener("mouseleave", function() {
      K === e && (K = null, it())
    });
    var s = document.createElement("button");
    s.type = "button", s.className = "fdsfc-bagbtn";
    var d = $(t);
    return s.setAttribute("aria-pressed", d ? "true" : "false"), s.setAttribute("aria-label", (d ? "Remove " : "Add ") + t.m + (d ? " from" : " to") + " your bag"), s.setAttribute("title", d ? "In your bag" : "Add to your bag"), s.textContent = d ? "✓" : "+", s.addEventListener("click", function() {
      rt(t)
    }), o.appendChild(i), o.appendChild(s), o
  }

  function drawMore() {
    if (listDrawn >= listRows.length) return void hideMore();
    var a = document.createDocumentFragment(),
      end = Math.min(listDrawn + PAGE, listRows.length);
    for (var k = listDrawn; k < end; k++) a.appendChild(mkRow(listRows[k]));
    /* The sentinel is a child of #fdsList, so appendChild MOVES it to the end
       rather than adding a second one. */
    listDrawn = end, bt.appendChild(a), listDrawn < listRows.length ? bt.appendChild(listMore) : hideMore()
  }

  /* Test hook, same bargain as __FDS_PK_TEST__ in picker.js: a test that
     measures a disc by reading its row cannot reach past row 50, and driving
     the scroller from a headless browser would be asserting on the observer
     rather than on the thing under test. verify-arm-ceiling.mjs uses this. */
  window.__FDS_LIST_TEST__ = {
    drawAll: function() {
      while (listDrawn < listRows.length) drawMore()
    },
    drawn: function() {
      return listDrawn
    }
  };

  function Et() {
    var t, n = function(t) {
      var e = J.by,
        n = J.dir;
      /* The sort is only for the rows. While the catalogue is closed only the
         COUNT is shown (#fdsCount, written even when closed), and a sort never
         changes a length, so it is skipped until the list is open. Opening the
         list re-runs Et() in full (listStale), so nothing is ever shown stale. */
      return listShown ? t.slice().sort(function(t, r) {
        var a;
        if ("name" === e) a = (t.m + t.v).localeCompare(r.m + r.v);
        else if ("stab" === e) a = o.indexOf(t.st) - o.indexOf(r.st);
        else if ("ease" === e) {
          var i = s(t),
            d = s(r);
          a = i[0] - d[0] || i[1] - d[1] || i[2] - d[2]
        } else a = t[e] - r[e];
        return 0 === a && (a = (t.m + t.v).localeCompare(r.m + r.v)), a * n
      }) : t
    }((t = ft.value.trim().toLowerCase(), e.filter(function(e) {
      return !(ht.value && e.v !== ht.value || pt.value && BND(e) !== pt.value || mt.value && e.st !== mt.value || vt.value && e.as !== vt.value || yt.checked && !(e.stock > 0) || t && -1 === (e.m + " " + e.v).toLowerCase().indexOf(t))
    })));
    if (gt.innerHTML = ("ease" === J.by ? "<b>Easiest first</b> — arm speed, then least fade, then most glide &middot; " : "") + "<b>" + n.length + "</b> of <b>" + e.length + "</b> discs" + (n.length !== e.length ? " &middot; filtered" : ""), !listShown) return void(listStale = !0);
    if (listStale = !1, n.length) {
      /* innerHTML="" drops the sentinel out of the DOM too; drawMore puts it
         back after the first chunk. The observer keeps watching the element
         either way -- it observes the node, not its position. */
      ensureMore(), listRows = n, listDrawn = 0, bt.innerHTML = "", drawMore(), listTick()
    } else listRows = [], listDrawn = 0, bt.innerHTML = '<p class="fdsfc-none">No discs match those filters.</p>'
  }
  ut = {}, e.forEach(function(t) {
    ut[t.v] = (ut[t.v] || 0) + 1
  }), Object.keys(ut).sort().forEach(function(t) {
    var e = document.createElement("option");
    e.value = t, e.textContent = t + " (" + ut[t] + ")", ht.appendChild(e)
  }), [ft, ht, pt, mt, vt, yt].forEach(function(t) {
    t.addEventListener("input", Et), t.addEventListener("change", Et)
  }), document.getElementById("fdsReset").addEventListener("click", function() {
    ft.value = "", ht.value = "", pt.value = "", mt.value = "", vt.value = "", yt.checked = !1, Et()
  }), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-sortbar button"), function(t) {
    t.addEventListener("click", function() {
      var e = t.getAttribute("data-sort");
      J.by === e ? J.dir = -J.dir : (J.by = e, J.dir = 1), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-sortbar button"), function(t) {
        var e = t.getAttribute("data-sort") === J.by;
        t.setAttribute("aria-pressed", e ? "true" : "false");
        var n = t.querySelector("span");
        if (n && t.removeChild(n), e) {
          var r = document.createElement("span");
          r.textContent = J.dir > 0 ? "↑" : "↓", t.appendChild(r)
        }
      }), Et()
    })
  });
  var xt = {
      "Very Understable": "Understable",
      Understable: "Understable",
      Stable: "Stable",
      Overstable: "Overstable",
      "Very Overstable": "Overstable"
    },
    wt = ["Understable", "Stable", "Overstable"],
    Ct = document.getElementById("fdsBagChips"),
    kt = document.getElementById("fdsBagGrid"),
    Lt = document.getElementById("fdsBagNote");

  function At() {}

  function bqlbl(n, l, c) {
    /* Remember where the DOT is before the de-overlap pass moves the label.
       Ryan, on a Caiman sitting 11px clear of its own endpoint: "weird glitch
       - the caiman doesn't line up like the other ones do".

       It is not a glitch. Three discs finished 82, 81 and 80 m -- their dots
       land 2 units apart and their labels need 12.5, so the stack below the
       first one is pushed down to make room. That is the pass doing its job.
       But a label naming a dot it is no longer beside is a bug whatever caused
       it, so anything that moves now draws a hairline back to what it names.
       Measured on the Heimburg bag: eight of eleven labels sit on their dot,
       two drift 4.5px, one drifts 11px. Only the drifters get a line, which is
       the point -- it appears when it is needed rather than always. */
    l.forEach(function(q) { q.dy = q.y });
    ["left", "right"].forEach(function(t) {
      var e = l.filter(function(e) {
          return "right" === t === e.right
        }).sort(function(t, e) {
          return t.y - e.y
        }),
        GAP = 12.5 * c,
        pin = 0;
      /* THE ONE YOU SELECTED DOES NOT MOVE. The cascade used to run top-down
         from the first label, so displacement accumulated downward and the
         disc at the bottom of a crowded cluster moved furthest -- which is how
         the focused Caiman, third in a 82/81/80 m pile-up, ended up 11px clear
         of its own dot while every disc it was being compared against sat
         neatly on theirs. The bold label is the one being read; it is the
         worst possible choice to displace.
         So the run is anchored on the focused label and pushed OUTWARD from
         there, down for the labels below it and up for the ones above. With no
         focused label on this side pin stays 0 and this is exactly the old
         top-down pass. */
      for (var i = 0; i < e.length; i++)
        if (e[i].focus) { pin = i; break }
      for (var r = pin + 1; r < e.length; r++)
        if (e[r].y - e[r - 1].y < GAP) e[r].y = e[r - 1].y + GAP;
      for (var u = pin - 1; u >= 0; u--)
        if (e[u + 1].y - e[u].y < GAP) e[u].y = e[u + 1].y - GAP;
    });
    l.forEach(function(t) {
      var lx = t.x + (t.right ? 9 * c : -9 * c),
        an = t.right ? "start" : "end";
      /* Drawn BEFORE the text so the label's own stroke halo covers where the
         line lands. 1.2 units is about 4px on a desktop canvas -- under that
         the label still reads as sitting on its dot and a leader is clutter. */
      if (Math.abs(t.y - t.dy) > 1.2) n.appendChild(T("line", {
        x1: t.x + (t.right ? 3.4 * c : -3.4 * c),
        y1: t.dy,
        x2: lx,
        y2: t.y,
        stroke: t.c,
        "stroke-width": .55 * c,
        "stroke-opacity": .45
      }));
      var e = T("text", {
          x: lx,
          y: t.y + 4.4 * c,
          "text-anchor": an,
          "font-size": (t.fs || 12.5) * c,
          "font-weight": t.fw || 650,
          fill: t.c,
          stroke: "var(--field-grass)",
          "stroke-width": 3.6 * c,
          "stroke-linejoin": "round",
          "paint-order": "stroke fill"
        });
      e.textContent = t.t;
      if (t.d) {
        var ts = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        ts.setAttribute("fill", "var(--muted)"), ts.setAttribute("font-weight", 620),
          ts.setAttribute("font-size", ((t.fs || 12.5) > 12 ? 10.4 : 8.6) * c),
          ts.textContent = "  " + t.d, e.appendChild(ts)
      }
      n.appendChild(e);
    })
  }

  function LPo(t, o) {
    var n = Wd(t) - 1 + o,
      r = 2.2 * Math.tanh(1.6 * n / 2.2),
      a = E(t.tu - r, Math.max(0, t.f - FK(r) * r), t.s, MIR(t), t.g),
      i = x(a),
      s2 = i > 0 ? x(E(t.tu, t.f, t.s, MIR(t), t.g)) / i : 1,
      d2 = (1 + TL(o) * o) * s2,
      c = g(ft2u(Wd(t) * j(t) * d2), 14, 1.35 * b);
    return [v + a.x3 * c, y + a.y3 * c]
  }
  var Mt = document.getElementById("fdsFacets"),
    Bt = document.getElementById("fdsTip");

  function Ht() {
    Bt.style.opacity = "0"
  }

  function It() {
    Mt.innerHTML = "";
    var t = 130,
      n = 20,
      o = function(t) {
        return n + (t - -5) / 6 * 172
      },
      i = function(t) {
        return 112 - (t - 0) / 5 * 106
      };
    a.forEach(function(a) {
      var s = e.filter(function(t) {
          return BND(t) === a
        }),
        d = document.createElement("div");
      d.className = "fdsfc-facet", d.innerHTML = "<h4>" + _(r[a]) + "</h4><p>" + s.length + " discs</p>";
      var l = T("svg", {
        viewBox: "0 0 200 " + t,
        role: "img",
        "aria-label": r[a] + ": turn against fade for " + s.length + " discs"
      });
      l.appendChild(T("line", {
        x1: n,
        y1: 112,
        x2: 192,
        y2: 112,
        class: "fdsfc-axis"
      })), l.appendChild(T("line", {
        x1: n,
        y1: 6,
        x2: n,
        y2: 112,
        class: "fdsfc-axis"
      })), l.appendChild(T("line", {
        x1: o(0),
        y1: 6,
        x2: o(0),
        y2: 112,
        class: "fdsfc-axis-mid"
      })), [-5, -3, -1, 0, 1].forEach(function(t) {
        var e = T("text", {
          x: o(t),
          y: 121,
          "text-anchor": "middle",
          class: "fdsfc-ticklbl"
        });
        e.textContent = t, l.appendChild(e)
      }), [0, 2, 4].forEach(function(t) {
        var e = T("text", {
          x: 16,
          y: i(t) + 2.4,
          "text-anchor": "end",
          class: "fdsfc-ticklbl"
        });
        e.textContent = t, l.appendChild(e)
      });
      var c = T("text", {
        x: 106,
        y: 129,
        "text-anchor": "middle",
        class: "fdsfc-ticklbl"
      });
      c.textContent = "turn", l.appendChild(c);
      var u = T("text", {
        x: 2,
        y: 11,
        class: "fdsfc-ticklbl"
      });
      u.textContent = "fade", l.appendChild(u);
      var f = {};
      s.forEach(function(t) {
        var e = t.tu + ":" + t.f,
          n = f[e] = (f[e] || 0) + 1,
          r = 2.399 * n,
          a = 1 === n ? 0 : Math.min(3.2, 1.05 * Math.sqrt(n)),
          s = X.hasOwnProperty(H(t)),
          d = !s && $(t),
          c = T("circle", {
            class: "dot",
            r: s ? 4 : d ? 3.6 : 2.6,
            cx: o(t.tu) + Math.cos(r) * a,
            cy: i(t.f) + Math.sin(r) * a
          });
        s ? (c.setAttribute("data-sel", ""), c.style.setProperty("--c", tt2(t))) : d && c.setAttribute("data-bag", ""), c.addEventListener("mousemove", function(e) {
          ! function(t, e) {
            Bt.innerHTML = e, Bt.style.left = t.clientX + "px", Bt.style.top = t.clientY + "px", Bt.style.opacity = "1"
          }(e, "<b>" + _(t.m) + "</b> &nbsp;<i>" + _(t.v) + "</i><br><i>" + B(t.s) + " / " + B(t.g) + " / " + B(t.tu) + " / " + B(t.f) + " &middot; " + _(t.st) + "</i>")
        }), c.addEventListener("mouseleave", Ht), c.addEventListener("click", function() {
          Ht(), nt(t)
        }), l.appendChild(c)
      }), d.appendChild(l), Mt.appendChild(d)
    })
  }! function() {
    var t = {};
    n.forEach(function(e) {
      (t[e.v] = t[e.v] || []).push(e.m)
    });
    var e = Object.keys(t).sort(function(e, n) {
      return t[n].length - t[e].length
    });
    document.getElementById("fdsMissing").innerHTML = "<h2>" + n.length + " discs are not on this chart</h2><p>We only publish flight numbers the manufacturer publishes. These discs have none we can source, so we have left them blank rather than guess.</p><ul>" + e.map(function(e) {
      return "<li><b>" + _(e) + "</b> (" + t[e].length + ") — " + _(t[e].sort().join(", ")) + "</li>"
    }).join("") + "</ul>"
  }(), document.getElementById("fdsFoot").innerHTML = "Flight numbers are a guide, not a promise. They describe a disc thrown flat by an above-average arm — not a pro, and not a beginner. Throw harder than that and a disc will turn more than its numbers suggest; throw softer and it will fade out early and never reach the turn at all. Every flight here is a new disc: as a disc seasons it gets straighter and loses fade, so a well-worn one of the same shape holds its line longer and finishes further than these numbers suggest. Plastic, weight and wind all move the line too. Every number here comes from the manufacturer’s own published figures for that disc, never from a retailer, aggregator or forum. The flight paths use the same curve as our individual disc pages, traced from Innova’s official flight charts. The distance scale is built from the arm you set above, so change the calibration and every line redraws — those figures are a fitted estimate, not a promise.";
  var _t = document.getElementById("fdsThrottle"),
    Tt = document.getElementById("fdsThrottleOut");

  function St() {
    if (w) {
      var t = Math.round(100 * w),
        e = Q[0],
        n = (t > 0 ? "Harder" : "Softer") + " · " + Math.abs(t) + "%";
      e && (n += " · " + e.m + " " + Y(e)), Tt.textContent = n
    } else Tt.textContent = "Your normal throw"
  }
  _t.addEventListener("input", function() {
    w = parseFloat(_t.value) / 100, isFinite(w) || (w = 0), St(), it(), ct(), hero()
  }), _t.addEventListener("dblclick", function() {
    w = 0, _t.value = 0, St(), it(), ct(), hero()
  });
  var Ft = document.getElementById("fdsPower"),
    Ot = document.getElementById("fdsPowerOut"),
    Rt = document.getElementById("fdsEasyNudge"),
    Nt = document.getElementById("fdsRefMold");

  function qt() {
    var t = W(),
      e = t < .8 ? "well below" : t < .95 ? "below" : t <= 1.08 ? "about the same as" : t < 1.3 ? "above" : "well above";
    if (Ot.innerHTML = "The arm the flight numbers assume would throw a " + _(V.m) + " about <b>" + Math.round("m" === z ? jr(V) * D : jr(V)) + ("m" === z ? " m" : " ft") + "</b>. Yours is <b>" + e + '</b> that, so every distance below is scaled to match. <span class="fdsfc-power__est">Estimate</span>' + (V.tu + V.f <= -2 ? "<br><br>⚠️ A very understable disc is a poor thing to measure with — it flips rather than running out of power. Pick something more stable if you can." : ""), Rt.innerHTML = "", t < .95) {
      var n = document.createElement("div");
      n.className = "fdsfc-easynudge", n.innerHTML = "Below the reference arm, fast and overstable discs will fade out early and never reach the numbers on the box. Worth sorting by what is actually throwable.";
      var r = document.createElement("button");
      r.type = "button", r.textContent = "Show me the easiest to throw", r.addEventListener("click", function() {
        J.by = "ease", J.dir = 1, Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-sortbar button"), function(t) {
          var e = "ease" === t.getAttribute("data-sort");
          t.setAttribute("aria-pressed", e ? "true" : "false");
          var n = t.querySelector("span");
          if (n && t.removeChild(n), e) {
            var r = document.createElement("span");
            r.textContent = "↑", t.appendChild(r)
          }
        }), Et(), document.getElementById("fdsListH").scrollIntoView({
          block: "start"
        })
      }), n.appendChild(r), Rt.appendChild(n)
    }
  }
  /* C3c -- THE REFERENCE DISC IS SEARCHED FOR, NOT SCROLLED TO.
     This used to fill #fdsRefMold with all 1,614 moulds as <option>s, grouped
     by type: 1,618 nodes on every page load, and a scroll through the entire
     sport to find the one disc you actually throw.

     #fdsRefMold survives as a hidden input holding the slug, and is still the
     only thing the engine reads. That is deliberate, not laziness: picker.js
     sets its .value and fires change to drive the chart from the calibration
     panel, and Ut() writes it straight from the r= hash. Both keep working
     untouched, and this box takes exactly the same route -- set .value, fire
     change -- so a bug here shows up in both paths or in neither.

     Same shape as the #fdsAdd search below, deliberately: one search idiom in
     this app, not two. */
  var RI = document.getElementById("fdsRefPick"),
    RR = document.getElementById("fdsRefRes");

  /* The box shows the CURRENT reference disc whenever it is not being typed in.
     Leaving a half-typed query sitting in it would be a straightforward lie
     about what the chart is scaled to. */
  function refLabel() {
    RI && V && (RI.value = V.m + " · " + V.v)
  }

  function refShut() {
    RR && (RR.hidden = !0, RR.innerHTML = "")
  }
  RI && RR && (RI.addEventListener("input", function() {
    var q = RI.value.trim().toLowerCase();
    if (!q) return refShut();
    var hits = e.filter(function(d) {
      return (d.m + " " + d.v).toLowerCase().indexOf(q) >= 0
    }).sort(function(x, y) {
      return (x.m + x.v).localeCompare(y.m + y.v)
    }).slice(0, 8);
    if (!hits.length) {
      RR.innerHTML = '<p class="fdsfc-add__none">No disc matches</p>', RR.hidden = !1;
      return
    }
    RR.innerHTML = "", hits.forEach(function(d) {
      var b = document.createElement("button");
      b.type = "button", b.className = "fdsfc-add__hit", b.innerHTML = "<b>" + _(d.m) + "</b><i>" + _(d.v) + " · " + _(r[d.t]) + "</i>", b.addEventListener("click", function() {
        Nt.value = I(d), Nt.dispatchEvent(new Event("change", {
          bubbles: !0
        })), refShut()
      }), RR.appendChild(b)
    }), RR.hidden = !1
  }), RI.addEventListener("focus", function() {
    RI.select()
  }), RI.addEventListener("keydown", function(ev) {
    /* preventDefault because this is an <input type="search">, and Chrome's
       native Escape on one of those CLEARS it -- as a default action, i.e.
       after this listener, so it would wipe the label refLabel just restored
       and leave the box blank next to a chart that is still scaled to a disc.
       #fdsAdd below wants that native clear; this box does not. */
    "Escape" === ev.key && (ev.preventDefault(), refLabel(), refShut(), RI.blur())
  }), document.addEventListener("click", function(ev) {
    RR.contains(ev.target) || ev.target === RI || (refLabel(), refShut())
  })), V = S["innova-destroyer"] || e[0], Nt.value = I(V), refLabel(), Nt.addEventListener("change", function() {
    var t = S[Nt.value];
    t && (V = t, refLabel(), qt(), it(), Et(), ct(), St(), hero(), Vt())
  }), Ft.addEventListener("input", function() {
    var t = parseFloat(Ft.value);
    !isFinite(t) || t <= 0 || (U = "m" === z ? t / D : t, qt(), it(), Et(), ct(), St(), hero())
  }), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-unit button"), function(t) {
    t.addEventListener("click", function() {
      var e = t.getAttribute("data-unit");
      e !== z && (z = e, Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-unit button"), function(t) {
        t.setAttribute("aria-pressed", t.getAttribute("data-unit") === z ? "true" : "false")
      }), Ft.min = "m" === z ? 20 : 60, Ft.max = "m" === z ? 275 : 900, Ft.value = "m" === z ? Math.round(U * D) : Math.round(U), Ft.step = 5, qt(), it(), Et(), ct(), St(), hero())
    })
  });
  var Pt = document.getElementById("fdsThrowCap"),
    // "Flat" carries an inline definition -- it is the assumption every number
    // on the page rests on, and a beginner has no way to guess it. Written as
    // HTML rather than text so the definition survives; see FLAT below.
    FLAT = '<span class="fdsfc-def" tabindex="0">flat<i>Released level &mdash; the disc tilted neither away from you nor towards you. It is the fairest way to compare two discs.</i></span>',
    Dt = {
      RHBH: "Right-hand backhand, thrown " + FLAT + ". Same scale for every disc.",
      LHBH: "Left-hand backhand, thrown " + FLAT + " &mdash; mirrored. Same scale for every disc.",
      RHFH: "Right-hand forehand &mdash; mirrored. Real forehands differ in detail.",
      LHFH: "Left-hand forehand &mdash; mirrored. Real forehands differ in detail."
    };

  function jt() {
    Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-throw button"), function(t) {
      t.setAttribute("aria-pressed", t.getAttribute("data-throw") === N ? "true" : "false")
    }), Pt.innerHTML = Dt[N] + (Q.some(isFH) ? " Dashed lines are forehands." : "")
  }

  function Vt() {
    var t = [];
    Q.length && t.push("d=" + Q.map(function(d) {
      return I(d) + ((d.__thr || N) !== N ? "~" + d.__thr : "")
    }).join(",")), "RHBH" !== N && t.push("t=" + N), V && "innova-destroyer" !== I(V) && t.push("r=" + I(V)), 348 !== Math.round(U) && t.push("p=" + Math.round(U)), 1 !== FHR && t.push("f=" + Math.round(100 * FHR));
    var e = location.pathname + location.search + (t.length ? "#" + t.join("&") : "");
    history.replaceState(null, "", e)
  }

  function Ut() {
    var t = location.hash,
      e = /(?:^|#|&)t=([A-Z]+)/.exec(t);
    e && R[e[1]] && (N = e[1]);
    var n = /(?:^|#|&)r=([a-z0-9-]+)/.exec(t);
    /* refLabel because this path sets the reference disc WITHOUT firing change
       -- on first load and on every hashchange -- so nothing else would update
       the box the visitor reads it from. */
    n && S[n[1]] && (V = S[n[1]], Nt.value = n[1], refLabel());
    var r = /(?:^|#|&)p=(\d+)/.exec(t);
    if (r) {
      var a = parseInt(r[1], 10);
      a >= 60 && a <= 900 && (U = a, Ft.value = "m" === z ? Math.round(a * D) : a)
    }
    var fh = /(?:^|#|&)f=(\d+)/.exec(t);
    if (fh) {
      var fv = parseInt(fh[1], 10);
      fv >= 50 && fv <= 150 && (FHR = fv / 100, FHI && (FHI.value = fv))
    }
    var o = /(?:^|#|&)d=([^&]+)/.exec(t);
    o && decodeURIComponent(o[1]).split(",").forEach(function(t) {
      var q = t.split("~"),
        e = S[q[0]],
        th = q[1] && R[q[1]] ? q[1] : N;
      e && addM(e, th)
    });
    var s = /(?:^|#|&)m-([a-z0-9-]+)/.exec(t);
    s && S[s[1]] && setTimeout(function() {
      var t = document.getElementById("m-" + s[1]);
      t && t.scrollIntoView({
        block: "center"
      })
    }, 60)
  }
  Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-throw button"), function(t) {
    t.addEventListener("click", function() {
      var was = N;
      N = t.getAttribute("data-throw"), Q.forEach(function(d) {
        d.__thr === was && (d.__thr = N)
      }), jt(), it(), ct(), Vt()
    })
  });
  var zt = document.getElementById("fdsThemeBtn");

  function Wt() {
    var t = document.documentElement.getAttribute("data-fds-theme");
    return !t || "dark" === t
  }

  function Yt() {
    zt.textContent = Wt() ? "Light mode" : "Dark mode"
  }
  zt.addEventListener("click", function() {
    document.documentElement.setAttribute("data-fds-theme", Wt() ? "light" : "dark"), Yt(), it(), It()
  }), Yt(), window.addEventListener("hashchange", function() {
    Q = [], X = {}, FO = 0, Ut(), jt(), qt(), it(), ct(), Et(), It()
  }), Ut(), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-sortbar button"), function(t) {
    var e = t.getAttribute("data-sort") === J.by;
    if (t.setAttribute("aria-pressed", e ? "true" : "false"), e) {
      var n = document.createElement("span");
      n.textContent = J.dir > 0 ? "↑" : "↓", t.appendChild(n)
    }
  }), Array.prototype.forEach.call(document.querySelectorAll(".fdsfc-preset button"), function(t) {
    t.addEventListener("click", function() {
      loadBag(t.getAttribute("data-bag"))
    })
  }), /(?:^|#|&)d=/.test(location.hash) || (BAGS.fds.forEach(function(t) {
    var e = S[t];
    e && addM(e)
  })), jt(), qt(), St(), it(), ct(), hero(), Et(), It(), setTimeout(function() {
    DOAN = !0, it()
  }, 3e3);
  (function() {
    var AI = document.getElementById("fdsAdd"),
      AR = document.getElementById("fdsAddRes");
    if (AI && AR) {
      var shut = function() {
        AR.hidden = !0, AR.innerHTML = ""
      };
      AI.addEventListener("input", function() {
        var q = AI.value.trim().toLowerCase();
        if (!q) return shut();
        var hits = e.filter(function(d) {
          return !X.hasOwnProperty(H(d)) && (d.m + " " + d.v).toLowerCase().indexOf(q) >= 0
        }).slice(0, 8);
        if (!hits.length) {
          AR.innerHTML = '<p class="fdsfc-add__none">No disc matches</p>', AR.hidden = !1;
          return
        }
        AR.innerHTML = "";
        hits.forEach(function(d) {
          var bt = document.createElement("button");
          bt.type = "button";
          bt.className = "fdsfc-add__hit";
          bt.innerHTML = "<b>" + _(d.m) + "</b><i>" + _(d.v) + " · " + B(d.s) + " / " + B(d.g) + " / " + B(d.tu) + " / " + B(d.f) + "</i>";
          bt.addEventListener("click", function() {
            nt(d), AI.value = "", shut(), AI.focus()
          });
          AR.appendChild(bt)
        });
        AR.hidden = !1
      });
      AI.addEventListener("keydown", function(ev) {
        "Escape" === ev.key && (AI.value = "", shut())
      });
      document.addEventListener("click", function(ev) {
        AR.contains(ev.target) || ev.target === AI || shut()
      })
    }
    var LT = document.getElementById("fdsListToggle"),
      LW = document.getElementById("fdsListWrap");
    LT && LW && LT.addEventListener("click", function() {
      var op = LW.hidden;
      /* Render before unhiding, and only when the filters moved while we were
         closed -- reopening an untouched list reuses the rows already there.
         listShown must be set first or Et() returns early on its own guard. */
      listShown = op, op && listStale && Et(),
        LW.hidden = !op, LT.setAttribute("aria-expanded", op ? "true" : "false"), LT.textContent = op ? "Hide the full list" : "Browse the full list"
    })
  })();
  var Gt = null;
  window.addEventListener("resize", function() {
    Gt || (Gt = requestAnimationFrame(function() {
      Gt = null, it()
    }))
  })
}();